module.exports = __webpack_public_path__ + "img/ranking-top12.f47957ac.png";